import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------
export const CAMERA_LIST_FETCH = 'unifi.CAMERA_LIST_FETCH'
export const CAMERA_CREATE = 'unifi.CAMERA_CREATE'
export const CAMERA_GET = 'unifi.CAMERA_GET'
export const CAMERA_UPDATE = 'unifi.CAMERA_UPDATE'

// ------------------------------------
// Action Creators
// ------------------------------------
export const listAllCameras = createWsAction({
    type: CAMERA_LIST_FETCH,
    messageType: 'core.camera.list-all-cameras',
    selectorKey: 'cameraList',
    fields: ['clientId']
})

export const createCamera = createWsAction({
    type: CAMERA_CREATE,
    messageType: 'core.camera.add-camera',
    selectorKey: 'cameraDetail',
    fields: ['clientId', 'siteId', 'zoneId', 'agentId', 'cameraSn', 'endpoint'],
});

export const getCamera = createWsAction({
	type: CAMERA_GET,
	messageType: 'core.camera.get-camera',
	selectorKey: 'cameraDetails',
	fields: ['clientId', 'cameraSn']
})

export const updateCamera = createWsAction({
	type: CAMERA_UPDATE,
	messageType: 'core.camera.edit-camera',
	selectorKey: 'cameraDetails',
	fields: ['clientId','targetClientId', 'cameraSn', 'changes']
})

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/camera.js